import React from "react";

export const CommunityDashboardPage = () => {
  return <div />;
};
